<template>
  <div class="UserRoleSelector">
    <div class="Tag-container">
      <span
        v-for="tag in modelValue"
        :key="tag.id"
        class="Tag Tag--orange"
      >
        {{ tag.name }}
        <i
          class="fa fa-times"
          @click="removeTag(tag)"
        />
      </span>
    </div>
    <tags-header
      :tags="modelValue"
      :modal-title="modalTitle"
      :has-quick-tag-removal="false"
      :is-searchable="isSearchable"
      @rmp:tag-selector:remove-tag="removeTag"
      @rmp:tag-selector:search-input="newSearchTerm"
    />
    <div class="Tag-selector-content">
      <tags-body
        :tags="modelValue"
        :available-tags="availableTags"
        :search-term="searchTerm"
        @rmp:tag-selector:remove-tag="removeTag"
        @rmp:tag-selector:add-tag="addTag"
      />
    </div>
  </div>
</template>
<script>
import TagSelectorMixin from '@/mixins/tag-selector-mixin';
import Header from './tags-header/header.vue';
import Body from './tags-body/body.vue';

export default {
  components: {
    'tags-header': Header,
    'tags-body': Body,
  },
  mixins: [TagSelectorMixin],
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },

  },
  emits: ['update:modelValue'],
  methods: {
    addTag(item) {
      const newResults = [...this.modelValue, item];
      this.$emit('update:modelValue', newResults);
    },
    removeTag(removalTag) {
      const newResults = this.modelValue.filter((tag) => tag.id !== removalTag.id);
      this.$emit('update:modelValue', newResults);
    },
  },
};
</script>

<style lang="scss" scoped>
.UserRoleSelector {
    text-align: left;
  }

.Tag-container {
  margin: 10px 0;

  .Tag {
    margin-right: 10px;
    margin-bottom: 2px;
  }
}

.Tag-selector-content {
  height: 400px;
  overflow: auto;
  overflow-x: hidden;
  max-height: 48vh;
}
</style>
